import React, {useState, useEffect} from "react";
import {TimePicker} from "antd";
import locale from "antd/es/date-picker/locale/tr_TR";
import {StyledTimePicker} from "../../credits/filterButton/HourFilter.style";
import {useStore} from "../../../hooks/useStore";
import moment from "moment";
import {runInAction} from "mobx";

const HourFilter = ({onTimeChange}) => {
    const stores = useStore();
    const [time, setTime] = useState(null);

    useEffect(() => {
        const endTime = stores.subcompanyUserStore.customerEndTime;

        if (endTime) {
            const formattedTime = moment(endTime, "HH:mm");
            setTime(formattedTime);
        } else {
            setTime(null);
        }
    }, [stores.subcompanyUserStore.customerEndTime]);

    const handleChange = value => {
        setTime(value);
        if (value) {
            const formattedTime = value.format("HH:mm");
            runInAction(() => {
                stores.subcompanyUserStore.setCustomerEndTime(formattedTime);
            });
            onTimeChange && onTimeChange(formattedTime);
        } else {
            runInAction(() => {
                stores.subcompanyUserStore.setCustomerEndTime("06:00");
            });
            onTimeChange && onTimeChange(null);
        }
    };

    const disabledHours = () => {
        const hours = [];
        for (let i = 7; i <= 23; i++) {
            hours.push(i);
        }
        return hours;
    };

    return (
        <>
            <StyledTimePicker>
                <TimePicker
                    value={time}
                    onChange={handleChange}
                    format="HH:mm"
                    placeholder="Kapanış Saati Seç"
                    minuteStep={5}
                    allowClear
                    locale={locale}
                    placement="bottomLeft"
                    popupClassName="custom-time-picker-popup"
                    getPopupContainer={trigger => trigger.parentElement}
                    showNow={false}
                    disabledHours={disabledHours}
                    hideDisabledOptions
                />
            </StyledTimePicker>
        </>
    );
};

export default HourFilter;
